import { GET, GETWithParams } from "./http.service";


export const getTranslations = async () => {
  const response = await GETWithParams(
    `Localization/key-value`,
    { platform: "FrontEnd" },
    false
  );
  return response;
};

export const getAllLanguages = async () => {
  const response = await GET(`Language`, false);
  return response;
};
